<template>
  <div>
    <p
      v-if="!wallet || !wallet.hasBillingDetails"
      class="billing-portal-link alert alert-light"
    >
      Before being able to make payments, you need to update your billing
      information
    </p>
    <div v-if="showLoader" class="payment-iframe">
      <InlineLoader></InlineLoader>
    </div>
    <iframe
      v-show="!showLoader && wallet && wallet.hasBillingDetails"
      :src="paymentIframeUrl"
      frameborder="0"
      class="payment-iframe"
      allow="payment *"
      @load="onIframeLoaded"
    ></iframe>
  </div>
</template>

<script>
import { getCurrentEnvironment } from "@/core/config/hapi/environments";
import InlineLoader from "@/view/content/InlineLoader";

// importing ApiService and using ApiService.url does not work, it's empty
// probably some lifecycle bug
const environment = getCurrentEnvironment();

export default {
  name: "BillingWidget",
  components: {
    InlineLoader
  },
  props: {
    wallet: Object,
    campaignId: String
  },
  emits: ["payment-success"],
  data() {
    return {
      showLoader: true
    };
  },
  computed: {
    paymentIframeUrl() {
      const params = {
        walletId: this.wallet.id,
        partnerId: environment.partnerId,
        returnUrl: window.location.href,
        successCallbackUrl: window.location.href,
        campaignId: this.campaignId || ""
      };

      if (this.$route.query.redirect) {
        params.redirect = this.$route.query.redirect;
      }

      if (this.$route.query.paymentMethodTypes) {
        params.paymentMethodTypes = this.$route.query.paymentMethodTypes;
      }

      const encodedParams = Object.keys(params)
        .map(key => `${key}=${encodeURIComponent(params[key])}`)
        .join("&");
      return `${environment.apiBaseUrl}wallet/topup.html?${encodedParams}`;
    }
  },
  methods: {
    async onWindowMessage(e) {
      if (
        !(
          `${e.origin}/`.startsWith(`${environment.apiBaseUrl}`) ||
          `${e.origin}/`.startsWith(`${environment.pkbBaseUrl}`)
        )
      ) {
        // console.log("Ignoring message from unknown origin", e.origin);
        // console.log(e.origin);
        return;
      }

      const EVENT_TYPES = {
        PAYMENT_STATUS: "payment_status",
        ERROR: "error"
      };

      // these are the status values from Stripe API
      // https://stripe.com/docs/payments/intents#intent-statuses
      const PAYMENT_STATUS = {
        REQUIRES_PAYMENT_METHOD: "requires_payment_method",
        REQUIRES_CONFIRMATION: "requires_confirmation",
        REQUIRES_ACTION: "requires_action",
        PROCESSING: "processing",
        SUCCEEDED: "succeeded",
        CANCELED: "canceled"
      };

      const data = JSON.parse(e.data);

      console.log("Received message from iframe", data);

      if (
        data.type === EVENT_TYPES.PAYMENT_STATUS &&
        data.payload.value === PAYMENT_STATUS.SUCCEEDED
      ) {
        const SUCCESS_MESSAGE_TIMEOUT_MS = 3000;

        setTimeout(async () => {
          // This is unreliable. There is no guarantee that payment
          // provider has made the postback to HAPI or that it was
          // succesfully handled or that the DB was updated
          // by the time we try to re-fetch the balance.
          this.$emit("payment-success");
          console.log("Issued payment success event", data);
        }, SUCCESS_MESSAGE_TIMEOUT_MS);
      } else if (data.type === EVENT_TYPES.ERROR) {
        switch (data.payload.statusCode) {
          case 422:
            // billing details not available
            console.log("Please fill your billing details before proceeding.");
            break;
          case 404:
            // wallet not found
            break;
          case 400:
            // invalid wallet id
            // or partnerId-walletId mismatch
            // or partner can't use wallet
            console.log("Bad request", data.payload.value);
            break;
          case 200:
            break;
          default:
            console.log("Unhandled error", data);
        }
      }
    },
    onIframeLoaded() {
      this.showLoader = false;
    }
  },
  created: function() {
    window.addEventListener("message", this.onWindowMessage);
  },
  destroyed: function() {
    window.removeEventListener("message", this.onWindowMessage);
  }
};
</script>

<style scoped>
.payment-iframe {
  width: 100%;
  height: 700px;
  border: none;
  margin-top: 10px;
}

.billing-portal-link {
  margin-top: 0.5rem;
}

.billing-portal-link a {
  display: block;
}
</style>
